import { styled, LazyImage } from '@teko/ui';
import Link from 'next/link';
import React from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Text = styled.div((props) => `
flex: 1;
font-size: 0.75rem;
margin-top: auto;
margin-bottom: auto;
margin-left: 0.5rem;
text-decoration: ${props.disableProductPromo ? "line-through" : "none"};
`);
const Wrapper = styled.div`
  display: flex;
  background: #fff;
  cursor: pointer;
`;
const ImageWrapper = styled.div`
  display: flex;
  align-items: start;
  height: fit-content;
  width: fit-content;
`;
const Gift = (_a) => {
  var _b = _a, {
    image,
    text,
    link,
    disableProductPromo,
    cartLineSelected = true,
    border = true
  } = _b, props = __objRest(_b, [
    "image",
    "text",
    "link",
    "disableProductPromo",
    "cartLineSelected",
    "border"
  ]);
  if (link)
    return /* @__PURE__ */ React.createElement(Link, {
      href: link
    }, /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(ImageWrapper, null, /* @__PURE__ */ React.createElement(LazyImage, __spreadProps(__spreadValues({
      contain: true,
      height: 32,
      width: 32,
      border
    }, image), {
      borderRadius: 2
    }))), /* @__PURE__ */ React.createElement(Text, {
      disableProductPromo: !!disableProductPromo
    }, text)));
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(ImageWrapper, null, /* @__PURE__ */ React.createElement(LazyImage, __spreadProps(__spreadValues({
    contain: true,
    height: 32,
    width: 32,
    border
  }, image), {
    borderRadius: 2
  }))), /* @__PURE__ */ React.createElement(Text, {
    disableProductPromo: !!disableProductPromo && cartLineSelected
  }, text));
};

export { Gift };
